import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-frontend-tech }}\n<MainContentLoading />",{ moduleName: "embercom/templates/apps/app/settings/loading.hbs" })